var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container agrement-container"},[_c('div',{staticClass:"title"},[_vm._v("数据说明：统计数字部分为非实时更新，可能存在延时")]),_vm._l((_vm.infoData.fields),function(item,i){return _c('div',{key:i},[_c('privacy-detail-content',{attrs:{"index":i,"fieldData":item}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }